import Transforms from './transforms'

const endpoints = {
    usersList: {
        path: '/admin/users',
        transform: Transforms.usersList,
    },
    usersCreate: {
        method: 'POST',
        path: '/admin/users',
        transform: Transforms.usersCreate,
    },
    // usersDetail: {
    //     path: '/admin/users/:id',
    //     transform: Transforms.usersDetail,
    // },
    usersEdit: {
        method: 'PATCH',
        path: '/admin/users/:id',
        transform: Transforms.usersEdit,
    },
    usersDelete: {
        method: 'DELETE',
        path: '/admin/users/:id',
        transform: Transforms.usersDelete,
    },
}

export default {
    name: 'admin',
    endpoints,
}
